import { round } from 'lodash';

export const toPercent = (num: number) => `${round(num * 100, 2)}%`;
